const questions = [
  // 1 Слайд \\ сумка [1]
  {
    questionDesc:
      "กระเป๋าคาดอกนั้นได้รับความนิยมเป็นอย่างมากในหมู่คนขับ, พ่อค้าและพนักงานขายของ ด้วยขนาดที่กระทัดรัดและใส่ของได้เยอะ พกไปได้ทุกที่อย่างสะดวกสบาย",
    questionText:
      "รู้หรือไม่? วัสดุที่ใช้ทำกระเป๋าคาดอกในช่วงปี 1990คืออะไรกันนะ?",
    answerOptions: [
      {
        answerText: "ยาง",
        answerResult:
          "ไวนิลโปร่งแสงนั้นถือเป็นวัสดุหลักยอดนิยมที่ใช้ทำกระเป๋าคาดอกในช่วงยุค 90 ซึ่งถือว่าเป็นกระแสที่มาแรงในสมัยนั้นเลยทีเดียวเชียว",
        result: false,
      },
      {
        answerText: "พลาสติก",
        answerResult:
          "ไวนิลโปร่งแสงนั้นถือเป็นวัสดุหลักยอดนิยมที่ใช้ทำกระเป๋าคาดอกในช่วงยุค 90 ซึ่งถือว่าเป็นกระแสที่มาแรงในสมัยนั้นเลยทีเดียวเชียว",
        result: false,
      },
      {
        answerText: "ตาข่ายโลหะ",
        answerResult:
          "ไวนิลโปร่งแสงนั้นถือเป็นวัสดุหลักยอดนิยมที่ใช้ทำกระเป๋าคาดอกในช่วงยุค 90 ซึ่งถือว่าเป็นกระแสที่มาแรงในสมัยนั้นเลยทีเดียวเชียว",
        result: false,
      },
      {
        answerText: "ไวนิลโปร่งแสง",
        answerResult:
          "ไวนิลโปร่งแสงนั้นถือเป็นวัสดุหลักยอดนิยมที่ใช้ทำกระเป๋าคาดอกในช่วงยุค 90 ซึ่งถือว่าเป็นกระแสที่มาแรงในสมัยนั้นเลยทีเดียวเชียว",
        result: true,
      },
    ],
    image: "images/1.webp",
  },

  // 2 слайд \\ шлем [4]
  {
    questionDesc:
      "หมวกกันน็อคถือเป็นหนึ่งในอุปกรณ์สำคัญเป็นอย่างยิ่งสำหรับคนขับ Maxim จึงใส่ใจในด้านรายละเอียดของตัวหมวกด้วยสีเหลืองสดใสและด้านความทนทานของหมวกด้วยการใช้วัสดุทำตัวหมวกที่หนาแข็งแรง และบุด้วยผ้านุ่มข้างใน",
    questionText:
      "คุณคิดว่าหมวกกันน็อกสำหรับจักรยานยนต์มีอายุยาวนานมาแล้วกี่ปีกันนะ?",
    answerOptions: [
      {
        answerText: "30 ปี",
        answerResult:
          "หมวกกันน็อคใบแรกของโลกถูกผลิตขึ้นในปี 1914 ซึ่งผลิตจากหนังสัตว์และไม้ก๊อก",
        result: false,
      },
      {
        answerText: "50 ปี",
        answerResult:
          "หมวกกันน็อคใบแรกของโลกถูกผลิตขึ้นในปี 1914 ซึ่งผลิตจากหนังสัตว์และไม้ก๊อก",
        result: false,
      },
      {
        answerText: "70 ปี",
        answerResult:
          "หมวกกันน็อคใบแรกของโลกถูกผลิตขึ้นในปี 1914 ซึ่งผลิตจากหนังสัตว์และไม้ก๊อก",
        result: false,
      },
      {
        answerText: "100 ปี",
        answerResult:
          "หมวกกันน็อคใบแรกของโลกถูกผลิตขึ้นในปี 1914 ซึ่งผลิตจากหนังสัตว์และไม้ก๊อก",
        result: true,
      },
    ],
    image: "images/2.webp",
  },

  // 3 слайд \\ дождевик [1]
  {
    questionDesc:
      "ตัวละครที่สวมเสื้อกันฝนสีเหลืองเป็นส่วนหนึ่งของวัฒนธรรมเป็นที่นิยมมาอย่างยาวนาน ไม่ว่าจะเป็น วินนี่เดอะพูห์ ที่มีเสื้อกันฝนสีเหลือง หรือภาพโปสเตอร์ของภาพยนตร์เรื่อง It ที่เราคุ้นเคย",
    questionText:
      "เสื้อกันฝนซิกเนเจอร์ของ Maxim ก็เป็นสีเหลืองสดใสเช่นกัน ทำไมถึงเป็นเช่นนั้น?",
    answerOptions: [
      {
        answerText: "เป็นหนึ่งในสีแท็กซี่ยอดนิยมทั่วโลก",
        answerResult: "สีเหลืองสดใสอันโดดเด่นคือสีสัญลักษณ์ของบริการ Maxim",
        result: false,
      },
      {
        answerText: "โดยทั่วไปแล้ว ผ้าที่กันน้ำมักเป็นสีเหลือง",
        answerResult: "สีเหลืองสดใสอันโดดเด่นคือสีสัญลักษณ์ของบริการ Maxim",
        result: false,
      },
      {
        answerText: "เป็นสีประจำบริการของ Maxim",
        answerResult: "สีเหลืองสดใสอันโดดเด่นคือสีสัญลักษณ์ของบริการ Maxim",
        result: true,
      },
      {
        answerText: "ได้รับเลือกจากการโหวตของชุมชน",
        answerResult: "สีเหลืองสดใสอันโดดเด่นคือสีสัญลักษณ์ของบริการ Maxim",
        result: false,
      },
    ],
    image: "images/3.webp",
  },

  // 4 слайд \\ лонгслив  [3]
  {
    questionDesc:
      "เสื้อแขนยาวนั้นมีประวัติการใช้งานมาอย่างยาวนานตั้งแต่ในช่วงศตวรรษที่ 19 เลยทีเดียว และได้มีการพัฒนาทั้งในด้านของวัสดุและรายละเอียดมาอย่างต่อเนื่องจนมาเป็นเสื้อแขนยาวในปัจจุบันนี้ รวมทั้งเสื้อแขนยาวของ Maxim ที่ได้มีการนำลายอนิเมะมาประยุกต์ใช้ด้วย",
    questionText: "ข้อใดถูกต้องที่สุดเกี่ยวกับเสื้อแขนยาวในยุคแรกๆ",
    answerOptions: [
      {
        answerText: "เสื้อแขนยาวผลิตขึ้นมาเพื่อผู้ชายโดยเฉพาะ",
        answerResult:
          "ในช่วงแรกนั้น เสื้อแขนยาวเป็นที่นิยมแค่ในหมู่เพศชาย แต่หลังจากศตวรรษที่ 20 เป็นต้นมาก็เริ่มมีการใช้งานทั้งเพศชายและหญิงอย่างกว้างขวาง",
        result: true,
      },
      {
        answerText:
          "เสื้อแขนยาวเริ่มได้รับความนิยมหลังจากที่แบรนด์ Coco Chanel ผลิต",
        answerResult:
          "ในช่วงแรกนั้น เสื้อแขนยาวเป็นที่นิยมแค่ในหมู่เพศชาย แต่หลังจากศตวรรษที่ 20 เป็นต้นมาก็เริ่มมีการใช้งานทั้งเพศชายและหญิงอย่างกว้างขวาง",
        result: false,
      },
      {
        answerText: "เสื้อแขนยาวมีแค่สีขาวเท่านั้น",
        answerResult:
          "ในช่วงแรกนั้น เสื้อแขนยาวเป็นที่นิยมแค่ในหมู่เพศชาย แต่หลังจากศตวรรษที่ 20 เป็นต้นมาก็เริ่มมีการใช้งานทั้งเพศชายและหญิงอย่างกว้างขวาง",
        result: false,
      },
      {
        answerText: "เสื้อแขนยาวจะต้องผลิตโดยใช้ฝ้าย 100% เท่านั้น",
        answerResult:
          "ในช่วงแรกนั้น เสื้อแขนยาวเป็นที่นิยมแค่ในหมู่เพศชาย แต่หลังจากศตวรรษที่ 20 เป็นต้นมาก็เริ่มมีการใช้งานทั้งเพศชายและหญิงอย่างกว้างขวาง",
        result: false,
      },
    ],
    image: "images/4.webp",
  },

  // 5 слайд \\ куртка [2]
  {
    questionDesc:
      "เสื้อแจ็กเก็ตบอมเบอร์ MAXIM (Maxim Branded Bomber): ไม่ใช่แค่เสื้อผ้า แต่คือสไตล์ที่เป็นคุณ! ออกแบบมาเพื่อลูกค้าและพนักงานขับรถโดยเฉพาะ ด้วยวัสดุคุณภาพเยี่ยม สวมใส่สบาย และดีไซน์ที่โดดเด่นไม่ซ้ำใคร",
    questionText:
      "รู้หรือไม่? ในตอนแรกเสื้อแจ็กเก็ตบอมเบอร์ถูกออกแบบมาเพื่อใครกันนะ และอะไรที่ทำให้กลายเป็นไอเท็มสุดฮิต?",
    answerOptions: [
      {
        answerText: "สำหรับนักปีนเขา ที่พักพิงจากสายลมแรงบนภูผา",
        answerResult:
          "เจาะลึกประวัติเสื้อแจ็กเก็ตนักบิน (Bombers) ไอเทมสุดคลาสสิกที่ออกแบบมาเพื่อท้าทายความหนาวเหน็บในห้องนักบินที่ติดลบถึง -50°C ทำจากหนังและขนสัตว์คุณภาพสูง ทนทานทุกสภาพอากาศ",
        result: false,
      },
      {
        answerText: "สำหรับนักบิน ออกแบบมาเพื่อสู้ความหนาวบนท้องฟ้า",
        answerResult:
          "เจาะลึกประวัติเสื้อแจ็กเก็ตนักบิน (Bombers) ไอเทมสุดคลาสสิกที่ออกแบบมาเพื่อท้าทายความหนาวเหน็บในห้องนักบินที่ติดลบถึง -50°C ทำจากหนังและขนสัตว์คุณภาพสูง ทนทานทุกสภาพอากาศ",
        result: true,
      },
      {
        answerText: "สำหรับกะลาสี หลบภัยจากพายุคลั่งกลางมหาสมุทร",
        answerResult:
          "เจาะลึกประวัติเสื้อแจ็กเก็ตนักบิน (Bombers) ไอเทมสุดคลาสสิกที่ออกแบบมาเพื่อท้าทายความหนาวเหน็บในห้องนักบินที่ติดลบถึง -50°C ทำจากหนังและขนสัตว์คุณภาพสูง ทนทานทุกสภาพอากาศ",
        result: false,
      },
      {
        answerText: "สำหรับนักปั่น เพื่อให้โลดแล่นได้แม้ในอากาศเย็นจัด",
        answerResult:
          "เจาะลึกประวัติเสื้อแจ็กเก็ตนักบิน (Bombers) ไอเทมสุดคลาสสิกที่ออกแบบมาเพื่อท้าทายความหนาวเหน็บในห้องนักบินที่ติดลบถึง -50°C ทำจากหนังและขนสัตว์คุณภาพสูง ทนทานทุกสภาพอากาศ",
        result: false,
      },
    ],
    image: "images/5.webp",
  },

  // 6 слайд \\ жилет  [3]
  {
    questionDesc:
      "เสื้อกั๊กเป็นไอเท็มที่สวมใส่ได้ทุกฤดูกาล เหมาะสำหรับทั้งสภาพอากาศร้อนและเย็น เสื้อกั๊กแบรนด์ Maxim มาพร้อมแถบสะท้อนแสง เพิ่มความปลอดภัยและมองเห็นได้ชัดเจนยิ่งขึ้นในที่มืด!",
    questionText:
      "ตามข้อมูลหนึ่ง เสื้อกั๊กถูกสวมใส่ครั้งแรกในงานแฟร์ คุณคิดว่าใครเป็นผู้สวมใส่?",
    answerOptions: [
      {
        answerText: "พ่อค้าชาวตุรกี",
        answerResult:
          "ตามหนึ่งเรื่องเล่า นักแสดงละครสัตว์ชาวฝรั่งเศสเป็นกลุ่มแรกที่สวมเสื้อกั๊ก พวกเขาเรียกเสื้อกั๊กว่า «gilie» ซึ่งมาจากชื่อตัวละครตลกที่มักสวมเสื้อกั๊กในการแสดง",
        result: false,
      },
      {
        answerText: "นักแสดงละครสัตว์ชาวฝรั่งเศส",
        answerResult:
          "ตามหนึ่งเรื่องเล่า นักแสดงละครสัตว์ชาวฝรั่งเศสเป็นกลุ่มแรกที่สวมเสื้อกั๊ก พวกเขาเรียกเสื้อกั๊กว่า «gilie» ซึ่งมาจากชื่อตัวละครตลกที่มักสวมเสื้อกั๊กในการแสดง",
        result: true,
      },
      {
        answerText: "นักแสดงตลกชาวอิตาลี",
        answerResult:
          "ตามหนึ่งเรื่องเล่า นักแสดงละครสัตว์ชาวฝรั่งเศสเป็นกลุ่มแรกที่สวมเสื้อกั๊ก พวกเขาเรียกเสื้อกั๊กว่า «gilie» ซึ่งมาจากชื่อตัวละครตลกที่มักสวมเสื้อกั๊กในการแสดง",
        result: false,
      },
      {
        answerText: "นักสู้วัวกระทิงชาวสเปน",
        answerResult:
          "ตามหนึ่งเรื่องเล่า นักแสดงละครสัตว์ชาวฝรั่งเศสเป็นกลุ่มแรกที่สวมเสื้อกั๊ก พวกเขาเรียกเสื้อกั๊กว่า «gilie» ซึ่งมาจากชื่อตัวละครตลกที่มักสวมเสื้อกั๊กในการแสดง",
        result: false,
      },
    ],
    image: "images/6.webp",
  },
];

export default questions;
